// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as BrokerageTermsRouteImport } from './routes/brokerage-terms'
import { Route as ClientRequirementRouteImport } from './routes/client-requirement'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as FormsRouteImport } from './routes/forms'
import { Route as IndexAliasRouteImport } from './routes/index-alias'
import { Route as InstallRouteImport } from './routes/install'
import { Route as MapSearchRouteImport } from './routes/map-search'
import { Route as NriInvestorsRouteImport } from './routes/nri-investors'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PropertiesRouteImport } from './routes/properties'
import { Route as SearchRouteImport } from './routes/search'
import { Route as TermsOfUseRouteImport } from './routes/terms-of-use'
import { Route as AdminCalendarRouteImport } from './routes/admin/calendar'
import { Route as AdminSecurityAlertsRouteImport } from './routes/admin/security-alerts'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as CampaignSlugRouteImport } from './routes/campaign/$slug'
import { Route as DeveloperDeveloperRouteImport } from './routes/developer/$developer'
import { Route as FSlugRouteImport } from './routes/f/$slug'
import { Route as PropertiesInLocalityRouteImport } from './routes/properties-in/$locality'
import { Route as PropertyIdRouteImport } from './routes/property/$id'
import { Route as AdminLeadsIdRouteImport } from './routes/admin/leads/$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const BrokerageTermsRoute = BrokerageTermsRouteImport.update({
            id: '/brokerage-terms',path: '/brokerage-terms',getParentRoute: () => rootRouteImport
          })
const ClientRequirementRoute = ClientRequirementRouteImport.update({
            id: '/client-requirement',path: '/client-requirement',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const FormsRoute = FormsRouteImport.update({
            id: '/forms',path: '/forms',getParentRoute: () => rootRouteImport
          })
const IndexAliasRoute = IndexAliasRouteImport.update({
            id: '/index-alias',path: '/index-alias',getParentRoute: () => rootRouteImport
          })
const InstallRoute = InstallRouteImport.update({
            id: '/install',path: '/install',getParentRoute: () => rootRouteImport
          })
const MapSearchRoute = MapSearchRouteImport.update({
            id: '/map-search',path: '/map-search',getParentRoute: () => rootRouteImport
          })
const NriInvestorsRoute = NriInvestorsRouteImport.update({
            id: '/nri-investors',path: '/nri-investors',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PropertiesRoute = PropertiesRouteImport.update({
            id: '/properties',path: '/properties',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const TermsOfUseRoute = TermsOfUseRouteImport.update({
            id: '/terms-of-use',path: '/terms-of-use',getParentRoute: () => rootRouteImport
          })
const AdminCalendarRoute = AdminCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AdminRoute
          })
const AdminSecurityAlertsRoute = AdminSecurityAlertsRouteImport.update({
            id: '/security-alerts',path: '/security-alerts',getParentRoute: () => AdminRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const CampaignSlugRoute = CampaignSlugRouteImport.update({
            id: '/campaign/$slug',path: '/campaign/$slug',getParentRoute: () => rootRouteImport
          })
const DeveloperDeveloperRoute = DeveloperDeveloperRouteImport.update({
            id: '/developer/$developer',path: '/developer/$developer',getParentRoute: () => rootRouteImport
          })
const FSlugRoute = FSlugRouteImport.update({
            id: '/f/$slug',path: '/f/$slug',getParentRoute: () => rootRouteImport
          })
const PropertiesInLocalityRoute = PropertiesInLocalityRouteImport.update({
            id: '/properties-in/$locality',path: '/properties-in/$locality',getParentRoute: () => rootRouteImport
          })
const PropertyIdRoute = PropertyIdRouteImport.update({
            id: '/property/$id',path: '/property/$id',getParentRoute: () => rootRouteImport
          })
const AdminLeadsIdRoute = AdminLeadsIdRouteImport.update({
            id: '/leads/$id',path: '/leads/$id',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminCalendarRoute: AdminCalendarRoute,AdminSecurityAlertsRoute: AdminSecurityAlertsRoute,AdminLeadsIdRoute: AdminLeadsIdRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,AuthRoute: AuthRoute,BlogRoute: BlogRouteWithChildren,BrokerageTermsRoute: BrokerageTermsRoute,ClientRequirementRoute: ClientRequirementRoute,ContactRoute: ContactRoute,DashboardRoute: DashboardRoute,FormsRoute: FormsRoute,IndexAliasRoute: IndexAliasRoute,InstallRoute: InstallRoute,MapSearchRoute: MapSearchRoute,NriInvestorsRoute: NriInvestorsRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,PropertiesRoute: PropertiesRoute,SearchRoute: SearchRoute,TermsOfUseRoute: TermsOfUseRoute,CampaignSlugRoute: CampaignSlugRoute,DeveloperDeveloperRoute: DeveloperDeveloperRoute,FSlugRoute: FSlugRoute,PropertiesInLocalityRoute: PropertiesInLocalityRoute,PropertyIdRoute: PropertyIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)